import { Box, createStyles, Grid, Theme, withStyles, WithStyles } from "@material-ui/core";
import SwiperCore, { Mousewheel, Virtual } from "@theankur/swiper/core";
import { Swiper, SwiperSlide } from "@theankur/swiper/react";
import classNames from "classnames";
import * as React from "react";
import { getGlobalUserId } from "shared/src/framework/network/headers";
import { Id } from "shared/src/models/framework/db";
import { getPollById, pollDelete, votePoll } from "shared/src/network/requests/poll/poll-req";
import { PollCard } from "shared/src/network/requests/poll/poll-req-models";
import { fetchUserCreatedPolls } from "shared/src/network/requests/user/user-req";
import { commonClasses, spacing } from "src/styles";
import CreateFlashPage from "./CreateFlashPage";
import Poll from "./Poll";
import ShareButton from "./ShareButton";
declare global {
    interface Window {
        fbq: any;
    }
}

SwiperCore.use([Mousewheel, Virtual]);

type Props = WithStyles<typeof styles> & {};

type State = {
    polls: Array<Id<PollCard>>;
    lastPollId: string;
    isLoading: boolean;
    showShareOverlay: boolean;
    newPollId: string;
};
const styles = (theme: Theme) =>
    createStyles({
        ...commonClasses,
        ...spacing(theme),
        loader: {
            "& circle": {
                animation: "none",
            },
        },
        userPollContainer: {
            maxWidth: "500px",
        },
        container: {
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            overflow: "hidden",
        },
        colorWhite: {
            color: "#fff",
        },
        maybeLaterLink: {
            color: theme.palette.grey[300],
            textDecoration: "underline",
            cursor: "pointer",
        },
        popup: {
            padding: theme.spacing(2),
            margin: "auto",
            borderRadius: theme.spacing(1),
            overflowY: "auto",
            maxHeight: `calc(100% - ${theme.spacing(4)}px)`,
            maxWidth: 350,
            backgroundColor: "#FFF",
        },
        hideOverFlow: {
            overflowY: "hidden",
        },
        setSameZIndex: {
            zIndex: 0,
        },
    });
class Component extends React.Component<Props, State> {
    swiper?: SwiperCore;
    currentUser?: string;
    constructor(props: Props) {
        super(props);
        this.state = {
            polls: [],
            isLoading: false,
            lastPollId: "",
            showShareOverlay: false,
            newPollId: "",
        };
        this.currentUser = getGlobalUserId();
        this.initPolls();
    }
    initPolls = async () => {
        this.swiper?.update();
        if (this.currentUser === null) return;
        this.setState({ isLoading: true });
        const apiResponse = await fetchUserCreatedPolls({});
        if (apiResponse.pollList.length > 0) {
            this.setState(
                { polls: apiResponse.pollList, lastPollId: apiResponse.pollList[0].id || "" },
                () => {
                    this.setState({ isLoading: false });
                }
            );
            this.swiper?.slideTo(this.state.polls.length, 0);
        } else {
            this.setState({ isLoading: false });
        }
    };
    handleOptionSelected = async (pollId: string, optionId: string | null) => {
        const { polls } = this.state;

        if (!this.currentUser) return;
        const poll = polls.find((each) => each.id === pollId);
        const index = polls.findIndex((each) => each.id === pollId);
        if (poll && !poll.myVote) {
            try {
                // Immediately slide to next poll and then submit request to backend
                const vote = { pollId: poll.id, userId: this.currentUser, optionId };
                const voteRes = await votePoll(vote);
                poll.myVote = { ...vote, id: voteRes.pollVoteId };
                const option = poll.options.find((each) => each.id === optionId);
                if (option) option.totalVote = (option?.totalVote || 0) + 1;
                polls[index] = { ...poll, totalVote: poll.totalVote + 1 };
                const newPolls = polls;
                this.setState({ polls: newPolls });
            } catch {}
        }
    };
    handlePollDelete = async (pollDeleteId: string) => {
        const { polls } = this.state;
        const isDeleted = await pollDelete({ pollId: pollDeleteId });
        if (isDeleted) {
            const newPollList = polls.filter((each) => each.id !== pollDeleteId);
            this.setState({ polls: newPollList });
        }
    };
    handleSwiperInit = (swiper: SwiperCore) => {
        this.swiper = swiper;
        swiper.update();
        this.swiper?.slideTo(this.state.polls.length, 0);
    };

    handleOnPollAdd = async (pollId: string) => {
        const { polls } = this.state;
        if (polls.length === 0) {
            this.setState({
                lastPollId: pollId,
            });
        }
        const apiResponse = await getPollById({ pollId: pollId });
        if (apiResponse) {
            let newPoll: Array<Id<PollCard>> =
                apiResponse.poll === undefined ? [] : [apiResponse.poll];
            this.setState((oldState) => ({
                polls: [...oldState.polls, ...newPoll],
                showShareOverlay: true,
                newPollId: pollId,
            }));
        }
    };

    handleSlideChange = async (swiper: SwiperCore) => {
        const { lastPollId } = this.state;
        if (!this.swiper?.activeIndex) return;

        if (this.swiper?.activeIndex < 5) {
            const apiResponse = await fetchUserCreatedPolls({ lastPollId: lastPollId });
            if (apiResponse) {
                this.setState((oldState) => ({
                    polls: [...apiResponse.pollList, ...oldState.polls],
                }));
            }
        }
    };
    renderShareOverlay = () => {
        let currentWindowHeight = window.innerHeight - 88;
        const { classes } = this.props;
        const { newPollId, polls } = this.state;
        const newPoll = polls.find((each) => each.id === newPollId);
        if (!newPoll) return;
        if (newPoll) {
            return (
                <Box
                    position="absolute"
                    height={currentWindowHeight}
                    width="100%"
                    sx={{ top: "32px", backgroundColor: "rgba(0, 0, 0, 0.75)" }}>
                    <Grid
                        container
                        sx={{ height: "100%" }}
                        direction="column"
                        spacing={0}
                        justifyContent="center"
                        alignItems="center">
                        <Grid item xs={1}>
                            <ShareButton
                                width={140}
                                poll={newPoll}
                                mode={"YOURPOLL"}
                                hideShareOverlay={() => {
                                    this.setState({ showShareOverlay: false });
                                }}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={1}
                            className={classNames(classes.mb, classes.maybeLaterLink)}
                            onClick={() => {
                                this.setState({ showShareOverlay: false });
                            }}>
                            Maybe Later
                        </Grid>
                    </Grid>
                </Box>
            );
        }
    };
    componentDidMount = () => {
        this.swiper?.update();
    };
    componentDidUpdate = (prevProps: Props, prevState: State) => {
        const { polls } = this.state;
        const { polls: prevPolls } = prevState;
        if (prevPolls.length !== polls.length) {
            this.swiper?.virtual.update(true);
        }
    };
    public render() {
        const { classes } = this.props;
        const { polls, showShareOverlay } = this.state;
        let currentWindowHeight = window.innerHeight - 88;
        return (
            <>
                {/* This commented section contains another approach to remove scroll by eliminating overflow, kept it to revisit 
            incase of issues.
            ============================================================================================================= */}
                {/* <Grid
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    wrap="nowrap"
                    className={classNames(classes.fullHeight)}>
                    <Grid item className={classes.fullWidth} sx={{ height: currentWindowHeight, overflow: "clip" }}>
                        
                    </Grid>
                </Grid> */}
                <Swiper
                    direction="vertical"
                    mousewheel
                    virtual
                    aria-label="SwiperComponent"
                    height={currentWindowHeight}
                    width={window.innerWidth}
                    className = {classes.setSameZIndex}
                    onInit={this.handleSwiperInit}
                    onSlideChange={this.handleSlideChange}>
                    {polls.map((poll, index) => (
                        <SwiperSlide key={`${poll.id}`} virtualIndex={index}>
                            <Grid
                                container
                                className={classes.container}
                                aria-label="SwiperComponentPollGrid">
                                <Poll
                                    poll={poll}
                                    mode="YOURPOLL"
                                    onOptionSelected={this.handleOptionSelected}
                                    onPollDelete={() => {
                                        this.handlePollDelete(poll.id);
                                    }}
                                    availableHeight={currentWindowHeight}
                                    uid={this.currentUser}
                                    isDisplayDelete={true}
                                />
                            </Grid>
                        </SwiperSlide>
                    ))}
                    <SwiperSlide key={"create-flash"} virtualIndex={polls.length}>
                        <Grid
                            container
                            className={classes.container}
                            aria-label="SwiperComponentPollGrid">
                            <CreateFlashPage onPollAdd={this.handleOnPollAdd} />
                        </Grid>
                    </SwiperSlide>
                </Swiper>
                {showShareOverlay === true && <>{this.renderShareOverlay()}</>}
            </>
        );
    }
}

const UserFlashSwiper = withStyles(styles)(Component);
export default UserFlashSwiper;
